<template>
  <span class="amount" v-if="amount != null">${{(+amount).toFixed(2)}}</span>
</template>
<script>
export default {
  props: ['amount']
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Currency.vue